<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div
        class="content  content-invitation"
        v-loading.fullscreen.lock="loading"
      >
       <div class="fir_box">
        <div class="invitate-wrap pd">
          <div class="main-title">自定义邀请函</div>
        <div class="main-sub">
           <div>1、自定义邀请函可选择公司名或品牌名展示在邀请函上；</div>
           <div>2、上传图片需注意空出文字和二维码位置，且上传的图片需符合法律法规要求；</div>
           <div>3、自定义的邀请函图片请自行下载保存。</div>
        </div>
        <div class="poster-wrap">
          <div class="left down-img">
            <el-image class="img-icon" v-if="imgUrl" :src="imgUrl"></el-image>
            <el-image class="img-bottom" :src="imgbUrl"></el-image>
            <div class="booth">
              {{ userdata.datainfo.hallNo }} {{ userdata.datainfo.boothNo }}
            </div>
            <div class="brand">
              {{ value == 1 ? userdata.datainfo.companyName :  userdata.datainfo.brandName == '' ? userdata.datainfo.companyName : userdata.datainfo.brandName}}
            </div>
            <el-image
              v-if="codeUrl"
              class="code-icon"
              :src="codeUrl"
            ></el-image>
          </div>
          <div class="right">
            <p class="title">选择文字</p>
            <el-select v-model="value" placeholder="请选择" @change="changeValue">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <p class="title">选择背景</p>
            <div class="upload-list">
              <div
                class="upload-image"
                :class="{ active: currentIndex == index }"
                v-for="(item, index) in imgs"
                :key="index"
                @click="changeBg(index)"
              >
                <el-image
                  class="image"
                  :src="$imgOssUrl + item.image"
                ></el-image>
                <img
                  v-if="item.company_id > 0"
                  class="close-icon"
                  src="../assets/close_icon.png"
                  alt=""
                  @click.stop="deleteImg(index, item.id)"
                />
              </div>
              <el-upload
                v-if="imgs.length < 5"
                class="upload-add"
                :action="$Url"
                :headers="headers"
                name="file"
                :on-success="handlePosterSuccess"
                :on-error="handlePosterError"
              >
                <i class="el-icon-plus"></i>
                <div class="el-upload__text">
                  <p style="color: #666; font-size: 16px">上传图片</p>
                  <p>建议尺寸800*1420</p>
                </div>
              </el-upload>
            </div>
            <div class="create-btn" @click="createPoster">生成邀请函</div>
          </div>
        </div>
       </div>
       </div>
       <div class="fir_box" style="margin-top: 20px;">
         <!-- 已制作的邀请函 -->
         <div class="diy-list pd">
          <h3>已制作的邀请函</h3>
          <div class="diy-item">
            <div
              class="down-img item"
              :id="'posterHtml_' + index"
              v-for="(item, index) in makeImgs"
              :key="index"
            >
              <el-image
                class="img-icon"
                v-if="item.image"
                :src="item.image"
              ></el-image>
              <el-image class="img-bottom" :src="imgbUrl"></el-image>
              <div class="booth">{{ item.hallNo }} {{ item.boothNo }}</div>
              <div class="brand">
                {{ item.characters }}
              </div>
              <el-image
                v-if="codeUrl"
                class="code-icon"
                :src="codeUrl"
              ></el-image>
              <div class="item-mask">
                <div class="item-btn" @click="downPoster(index)">下载</div>
                <div class="item-btn del-btn" @click="delMakeImg(index, item.id)">删除</div>
              </div>
            </div>
          </div>
        </div>
       </div>
       
          <!-- 下载模版 -->
          <!-- <div class="down-img" id="posterHtml"> -->
            <!-- <el-image class="img-icon" :src="bgUrl"></el-image> -->
            <!-- <div class="down-text">
              <p>
                {{ userdata.datainfo.hallNo }} {{ userdata.datainfo.boothNo }}
              </p>
              <p style="font-size: 14px">{{ userdata.datainfo.companyName }}</p>
            </div>
            <el-image
              v-if="codeUrl"
              class="code-icon"
              :src="codeUrl"
            ></el-image> -->
            <!-- <div class="down-mask" @click="diyPoster">
              <a class="down-btn">自定义邀请函</a>
            </div> -->
            <!-- <div class="down-mask" @click="downPoster">
              <a class="down-btn">下载邀请函</a>
            </div> -->
          <!-- </div> -->
          <!-- 总邀请函 -->
          <!-- <div class="invitation-infor flex">
              <div class="icon"></div>
              <div>总邀请人数</div>
              <div class="number">{{ totals }}</div>
            </div> -->
          <!-- 列表 -->
          <div class="fir_box" style="margin-top: 20px;">
            <div class="invitation-table">

              <div class="table-title pd">
              已邀请观众列表<span>(总邀请人数{{ totals }})</span>
            </div>
            <div class="in_list pd">
               <div class="in_item">
                   <div>登记时间：2023-02-09 09:00</div>
                   <div class="in_sir"><span>宗伯峰</span><span>索奇智能科技（北京）有限公司</span></div>
                   <div>销售部-总经理</div>
               </div>
               <div class="in_item">
                   <div class="in_fir">登记时间：2023-02-09 09:00</div>
                   <div class="in_sir"><span>宗伯峰</span><span>索奇智能科技（北京）有限公司</span></div>
                   <div>销售部-总经理</div>
               </div>
               <div class="in_item">
                   <div class="in_fir">登记时间：2023-02-09 09:00</div>
                   <div class="in_sir"><span>宗伯峰</span><span>索奇智能科技（北京）有限公司</span></div>
                   <div>销售部-总经理</div>
               </div>
               <div class="in_item">
                   <div class="in_fir">登记时间：2023-02-09 09:00</div>
                   <div class="in_sir"><span>宗伯峰</span><span>索奇智能科技（北京）有限公司</span></div>
                   <div>销售部-总经理</div>
               </div>
            </div>

            </div> 
           
          </div>
          <!-- <div class="invitation-table">
            <div class="table-title">
              已邀请观众列表<span>(总邀请人数{{ totals }})</span>
            </div>
            <el-table
              class="my-table"
              :data="tableData"
              stripe
              style="width: 100%"
              :header-cell-style="{
                fontSize: '14px',
              }"
              :cell-style="{ fontSize: '14px' }"
            >
              <el-table-column label="姓名">
                <template slot-scope="scope">
                  {{ scope.row.user.nick_name }}
                </template>
              </el-table-column>
              <el-table-column label="公司">
                <template slot-scope="scope">
                  {{ scope.row.user.company_name }}
                </template>
              </el-table-column>
              <el-table-column label="部门">
                <template slot-scope="scope">
                  {{ scope.row.user.department }}
                </template>
              </el-table-column>
              <el-table-column label="职务">
                <template slot-scope="scope">
                  {{ scope.row.user.duty }}
                </template>
              </el-table-column>
              <el-table-column label="登记时间">
                <template slot-scope="scope">
                  {{ scope.row.user.update_time }}
                </template>
              </el-table-column>
            </el-table>
          </div> -->
  
        <el-pagination
          v-if="totals > 0"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="totals"
        >
        </el-pagination>
        <el-button @click="next">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail, userRegister, getCode,setBackground, makeBackground } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import html2canvas from "html2canvas";
export default {
  components: { top, navMenu },
  name: "invitation",
  data() {
    return {
      loading: false,
      active: 4,
      headers: {},
      imgUrl: "",
      imgbUrl: '',
      userdata: {
        datainfo: {
          hallNo: "",
          boothNo: "",
        },
      },
      options: [
        {
          value: 1,
          label: "公司名",
        },
        {
          value: 2,
          label: "品牌名",
        },
      ],
      value: 1,
      imgs: [], // 背景图片
      currentIndex: 0,
      makeImgs: [], //已制作的邀请函列表
      content: {
        title_brief: "",
      },
      tableData: [],
      totals: 0,
      page: 1,
      pagesize: 10,
      currentPage: 1,
      codeUrl: "",
      bgUrl: ''
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/invitation";
    });
    this.active = index;
    this.id = this.$route.query.id;
    this.userdata = JSON.parse(localStorage.getItem("userdata"));
    // 获取详情
    this.getContent(this.id);
    //获取列表
    this.getList();
    //获取背景图
    this.getBackgroundList();
    //获取已制作的邀请函
    this.getMakeBackground();
    this.getXcxCode();
  },
  methods: {
      // 切换文字
      changeValue(val){
        console.log(val, '===val')
          if(val == 2 && this.userdata.datainfo.brandName == ''){
            this.$message.warning('未设置品牌名，将展示公司名');
          }
    },
    //获取背景图
    getBackgroundList() {
      setBackground("get", {})
        .then((res) => {
          //console.log(res, '======res')
          if (res.code == 200) {
            let data = res.data;
            if (data.length > 0) {
              this.imgs = data;
              //背景默认第一个
              this.imgUrl = this.$imgOssUrl + this.imgs[0].image;
            }
          }
        })
        .catch((err) => {});
    },
    //获取已制作的邀请函列表
    getMakeBackground() {
      makeBackground("get", {})
        .then((res) => {
          //console.log(res, "======获取已制作的邀请函列表");
          if (res.code == 200) {
            let data = res.data;
            if (data.length > 0) {
              data.forEach(item => {
                item.image = this.$imgOssUrl + item.image
              });
              this.makeImgs = data;
            }
          }
        })
        .catch((err) => {});
    },
    //获取动态小程序码
    getXcxCode() {

      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let data = this.$qs.stringify({
        scene: "&mid=" + "E" + "&sid=" + userdata.datainfo.id + "&e=C",
        page: "pages/preCheck/preCheck",
      });
     
      getCode(data).then((res) => {
          //console.log(res, "======获取动态小程序码");
          if (res.status == 200) {
            this.codeUrl = `data:image/png;base64,${res.data}`;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 海报上传成功
    handlePosterSuccess(resData, file, fileList) {
      if (resData.code === 200) {
        //console.log(resData.data, "====data");
        let data = this.$qs.stringify({
          image: resData.data,
        });
        setBackground("PUT", data)
          .then((res) => {
            //console.log(res, "======res");
            if (res.code == 200) {
              let data = res.data;
              if (data.length > 0) {
                this.imgs = data;
              }
            }
          })
          .catch((err) => {});
      }
    },
    //删除背景图
    deleteImg(index, id) {
      this.$confirm("确定要删除当前背景图吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            id,
          };
          setBackground("delete", data)
            .then((res) => {
              console.log(res, "======res");
              if (res.code == 200) {
                this.imgs.splice(index, 1);
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    // 海报上传失败
    handlePosterError(err, file, fileList) {
      this.$message.error(err.message);
    },
    //切换选中海报
    changeBg(index) {
      //当前选中海报背景
      this.currentIndex = index;
      //左侧展示海报背景
      this.imgUrl = this.$imgOssUrl + this.imgs[index].image;
    },
    //生成邀请函
    createPoster() {
      let { currentIndex, imgs, userdata, value } = this;
      let data = this.$qs.stringify({
        company_id: imgs[currentIndex].company_id,
        characters_type: value,
        characters:
          value == 1
            ? userdata.datainfo.companyName
            : userdata.datainfo.brandName == ""
            ? userdata.datainfo.companyName
            : userdata.datainfo.brandName,
        hallNo: userdata.datainfo.hallNo,
        boothNo: userdata.datainfo.boothNo,
        image: imgs[currentIndex].image,
      });
      makeBackground("PUT", data)
        .then((res) => {
          if (res.code == 200) {
            let data = res.data;
            if (data.length > 0) {
              data.forEach(item => {
                item.image = this.$imgOssUrl + item.image
              });
              this.makeImgs = data;
            }
          }
        })
        .catch((err) => {});
    },
    //删除已制作的邀请函
    delMakeImg(index, id){
      this.$confirm("确定要删除邀请函吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            id,
          };
          makeBackground("delete", data)
            .then((res) => {
              if (res.code == 200) {
                this.makeImgs.splice(index, 1);
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    // 下载海报
    downPoster(index) {
      let that = this;
      that.loading = true;
      //图片转成base64
      let image = that.makeImgs[index].image;
      that.convertImageToBase64(image, that.base64CallBack, index);
      let id = 'posterHtml_' + index;
      let posterDOM = document.getElementById(id);
      html2canvas(posterDOM, {
        width: posterDOM.offsetWidth,
        height: posterDOM.offsetHeight,
        //按比例增加分辨率
        scale: window.devicePixelRatio * 2.5, // 设备像素比
        useCORS: true, //（图片跨域相关）
        allowTaint: true, //允许跨域（图片跨域相关）
        logging: false,
        letterRendering: true,
      }).then(function (canvas) {
        let posterImgURL = canvas.toDataURL("image/png");
        let a = document.createElement("a");
        a.download = "邀请函";
        a.href = posterImgURL;
        a.dispatchEvent(new MouseEvent("click"));
        that.loading = false;
      });
    },
    //下载邀请函时，图片转base64
    convertImageToBase64(imgUrl, callback, index) {
      const image = new Image();
      image.setAttribute('crossOrigin', 'anonymous');
      image.src = imgUrl;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataUrl = canvas.toDataURL();
        callback && callback(dataUrl, index);
      };
    },
    base64CallBack(base64, index) {
      this.makeImgs[index].image = base64;
    },
    //自定义邀请函
    diyPoster() {
      this.$router.push({
        path: '/diyPoster',
      });
    },
    //  获取内容
    getContent(id) {
      getDetail({ id })
        .then((res) => {
          //console.log(res, "======菜单进度");
          if (res.code == 200) {
            let { data } = res.data;
            this.content = data[0];
            if (data[0].step) {
              this.content.title_brief = data[0].step.title_brief;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分页相关
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    //获取列表
    getList() {
      let data = this.$qs.stringify({
        pagesize: this.pagesize,
        page: this.page,
      });
      this.loading = true;
      userRegister(data)
        .then((res) => {
          this.loading = false;
          //console.log(res.data, "=====获取列表");
          if (res.code == 200) {
            let { data } = res.data;
            this.tableData = data.list;
            this.totals = data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    next() {
      if (this.totals > 0) {
      
        this.active = this.active + 1;
        this.toLink();
      } else {
        this.$confirm(
          "还未有观众接受邀请，您可以随时返回此页面下载邀请函",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            if (
              this.stepMenuList[this.active].state != "finish" &&
              this.stepMenuList[this.active].state != "process" &&
              this.stepMenuList[this.active].state != "error"
            ) {
              // this.updateStepStart(this.stepMenuList[this.active].menu_mark, 5);
            }
            this.active = this.active + 1;
            this.toLink();
          })
          .catch(() => {});
      }
    }, //跳转
    toLink() {
      let { link_url, menu_title, id } = this.stepMenuList[this.active];
      if (link_url == "/exhibitorManual" || link_url == "/standPrepare") {
        this.$router.push({
          path: link_url,
          query: {
            id: id,
            title: menu_title,
          },
        });
      } else {
        this.$router.push({
          path: link_url
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.in_sir{
  margin: 20px 0 15px;
  span:nth-child(1){
    display: inline-block;
    margin-right: 20px
  }
}
.content-type {
  .invitate-wrap {
    // display: flex;
    margin-top: 30px;
  }
  .down-img {
    width: 350px;
    height: auto;
    cursor: pointer;
    position: relative;
    margin-right: 60px;
    .img-icon {
      width: 100%;
      height: 100%;
    }
    .down-text {
      position: absolute;
      top: 478px;
      left: 30px;
      width: 130px;
      color: #fff;
      box-sizing: border-box;
      line-height: 20px;
      font-size: 16px;
      p {
        width: 100%;
      }
    }
    .code-icon {
      width: 46px;
      height: 46px;
      position: absolute;
      z-index: 9;
      bottom: 35px;
      right: 14px;
      border-radius: 50%;
      // width: 80px;
      // height: 80px;
      // position: absolute;
      // bottom: 63px;
      // right: 28px;
      // border-radius: 50%;
    }
    .down-mask {
      opacity: 0;
      width: 350px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0px;
      z-index: 9;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.1s;
      background: rgba(0, 0, 0, 0.4);
      .down-btn {
        width: 136px;
        height: 40px;
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        line-height: 40px;
        text-align: center;
        background: #1677ff;
        border-radius: 5px;
        margin-top: 30px;
      }
    }
  }
  .down-img:hover {
    .down-mask {
      opacity: 1;
    }
  }
  .invitation-infor {
    width: 254px;
    height: 82px;
    padding: 23px;
    font-size: 14px;
    color: #959ec4;
    margin-left: 43px;
    margin-top: 50px;
    border-radius: 18px;
    box-sizing: border-box;
    border: 1px solid #959ec4;
    background: #fafcfe;
    .icon {
      width: 9px;
      height: 9px;
      margin-right: 12px;
      background: #fa6400;
      border: 13px solid #f9ece4;
      border-radius: 50%;
    }
    .number {
      flex: 1;
      font-size: 30px;
      font-weight: 500;
      color: #373c52;
      text-align: right;
    }
  }
  // 已邀请观众列表
  .invitation-table {
    // margin-top: 30px;
    // padding-top: 50px;
    // border-top: 10px solid #f2f4f8;
    flex: 1;
    .table-title {
      font-size: 20px;
      font-weight: 500;
      color: #2c2c2e;
      line-height: 28px;
      span {
        font-size: 16px;
        color: #636366;
      }
    }
  }
}
.my-table {
  color: #888;
  font-size: 16px;
  margin-top: 10px;
}
.my-table tbody td,
.my-table tbody th {
  height: 70px;
  box-sizing: border-box;
}
.my-table tbody th,
.my-table tbody tr {
  background: #f2f6fb;
}
.my-table tbody tr.is-new {
  color: #0e0e0e;
}
.my-table tbody tr td .check-btn {
  color: #1677ff;
  cursor: pointer;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff;
}
.el-table td,
.el-table th.is-leaf {
  border-bottom: 0 none;
}
/* 表格最外层边框-底部边框 */
.el-table--border::after,
.el-table--group::after {
  width: 0;
}
.my-table::before {
  width: 0;
}
.my-table tbody tr td:first-child {
  border-radius: 10px 0 0 10px;
}
.my-table tbody tr td:last-child {
  border-radius: 0 10px 10px 0;
}
.content-invitation .el-pagination {
  margin-top: 30px;
  text-align: center;
  .el-pager li,
  .el-pagination__total {
    font-size: 14px;
  }
  .el-pagination__jump {
    font-size: 14px;
  }
}


.go-back {
    margin-left: 30px;
  }
  .main-title {
    margin-top: 20px;
  }
  .main-sub {
    font-size: 22px;
    color: #646889;
    line-height: 30px;
    margin-top: 8px;
    margin-bottom: 50px;
  }
  .poster-wrap {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 30px;
    .left {
      width: 220px;
      height: 393px;
      margin-right: 50px;
      .img {
        width: 100%;
      }
    }
    .right {
      width: 600px;
      .title {
        color: #000;
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 3px;
      }
      .el-select {
        width: 100%;
        margin-bottom: 20px;
      }
      .upload-list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
        .active {
          border: 2px solid #1677ff;
        }
        .upload-image {
          width: 88px;
          height: 137px;
          cursor: pointer;
          margin-right: 18px;
          position: relative;
          .close-icon {
            position: absolute;
            top: 3px;
            right: 3px;
            width: 20px;
            height: 20px;
          }
          .image {
            width: 100%;
            height: 100%;
          }
        }
      }
      .upload-add {
        width: 137px;
        height: 137px;
        line-height: 20px;
        border-radius: 2px;
        overflow: hidden;
        background: #f9f9f9;
        border: 1px dashed #bfbfbf;
        .el-icon-plus {
          color: #999 !important;
          font-size: 40px;
          margin: 15px 0 0;
          line-height: 45px;
        }
        .el-upload__text {
          height: auto;
          color: #999;
          font-size: 14px;
          line-height: 18px;
          p {
            margin: 5px 10px 0;
          }
        }
      }
      .create-btn {
        width: 218px;
        height: 50px;
        color: #fff;
        font-size: 14px;
        line-height: 50px;
        text-align: center;
        // margin-top: 30px;
        margin-top: 75px;
        cursor: pointer;
        border-radius: 8px;
        background: #1677ff;
        border: 1px solid #1677ff;
        transition: all 0.2s;
        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
  .diy-list {
    padding-top: 30px;
    h3 {
      font-size: 26px;
      font-weight: 500;
      color: #2c2c2e;
      line-height: 37px;
      margin-bottom: 20px;
    }
  }
  .down-img {
    width: 350px;
    height: auto;
    cursor: pointer;
    position: relative;
    margin-right: 60px;
    margin-bottom: 20px;
    .img-icon {
      width: 100%;
      height: 100%;
    }
    .img-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    }
    .booth {
      position: absolute;
      top: 220px;
      left: 0;
      width: auto;
      color: #fff;
      font-weight: 500;
      font-size: 20px;
      padding: 3px 8px 3px 13px;
      max-width: 100%;
      background: rgba($color: #E9BA77, $alpha: 0.88);
    }
    .brand {
      position: absolute;
      top: 255px;
      left: 0;
      color: #fff;
      font-size: 15px;
      max-width: 100%;
      min-width: 125px;
      font-weight: 500;
      padding: 3px 7px 3px 13px;
      background: rgba($color: #E9BA77, $alpha: 0.88);
    }
    .code-icon {
      width: 46px;
      height: 46px;
      position: absolute;
      z-index: 9;
      bottom: 35px;
      right: 14px;
      border-radius: 50%;
    }
  }
  .diy-item {
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 220px;
      height: 392px;
      margin-right: 33px;
      position: relative;
      .image {
        width: 100%;
        height: 100%;
      }
      .booth {
        top: 230px;
        font-size: 18px;
      }
      .brand {
        top: auto;
        bottom: 115px;
        min-width: auto;
        font-size: 13px;
        font-weight: 400;
        padding-right: 15px;
      }
      .code-icon {
        width: 48px;
        height: 48px;
        bottom: 34px;
        right: 13px;
      }
      &:hover .item-mask{
        opacity: 1;
      }
      .item-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 99;
        opacity: 0;
        padding: 100px 0 0;
        transition: all 0.3s;
        box-sizing: border-box;
        background: rgba($color: #000, $alpha: 0.4);
        .item-btn {
          width: 110px;
          height: 40px;
          color: #fff;
          font-size: 14px;
          line-height: 40px;
          text-align: center;
          background: #1677ff;
          border-radius: 5px;
          margin: 30px auto 0;
          display: block;
          &:hover{
            opacity: 0.95;
          }
        }
        .del-btn{
          background: #FF4D4F;
        }
      }
    }
  }
  .el-upload-list__item {
  transition: none !important;
  -webkit-transition: nonne !important;
}
.el-upload-list__item-name {
  transition: none !important;
  -webkit-transition: nonne !important;
}
.el-upload-list--text {
  display: none !important;
}
.fir_box{
  background: #fff;
  border-radius: 6px;
  padding: 20px 0;
  box-sizing: border-box;
}
.in_list{
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.in_item{
  width: -webkit-calc((100% - 20px * 3)/ 3);
  width: calc((100% - 20px * 3) / 3);
  margin: 0 20px 20px 0; 
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid #eee;
  border-radius: 6px;
}
@media only screen and (max-width: 1280px) {
  .in_item{
  width: -webkit-calc((100% - 20px * 2)/ 2);
  width: calc((100% - 20px * 2) / 2);
}
}
@media only screen and (max-width: 767px) {
  .code-icon {
      width: 56px !important;
      height: 56px !important;
      position: absolute;
      z-index: 9;
      bottom: 40px !important;
      right: 15px !important;
      border-radius: 50%;
    }
    .table-title{
      font-size: 16px !important;
    }
    .table-title span{
      font-size: 12px !important;
    }
    .el-button{
      font-size: 15px !important;
    }
    .title{
      font-size: 16px !important;
    }
    .diy-list h3 {
      font-size: 18px !important;
    }
    .diy-item .item{
      width: 100% !important;
      margin-right: 50px !important;
    }
.content{
  padding: 30px 0 130px 0;
}
.fir_box{
 width: 100%;
 margin: auto;
}
.in_item{
  width: 100%;
}
.right{
  width: 100% !important;
}
.upload-image{
  width: 28% !important;
  margin-right: 10px !important;
  margin-bottom: 10px !important;
}

.main-sub{
  font-size: 16px !important;
}
.poster-wrap .left{
  width: 100% !important;
}


}
</style>
<style>
@media only screen and (max-width: 767px) {
  .el-message-box{width: 300px !important;}
}
</style>